import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { AsYouType } from 'libphonenumber-js';

import { isValidPhoneNumber } from '@core/common-legacy';

@Pipe({ name: 'rtPhoneNumber', standalone: true })
export class PhoneNumberPipe implements PipeTransform {
  public transform(number?: string): string {
    if (!number) return '';
    if (!isValidPhoneNumber(number)) return number;
    return new AsYouType().input(number) || number;
  }
}
